export const deleteSchemeDetailedDialogTranslations = {
    en: {
        delete: "Delete",
        deleteSuccess: "deleted successfully",
        deleteError: "Failed to delete"
    },
    mr: {
        delete: "हटवा",
        deleteSuccess: " यशस्वीरित्या हटवले",
        deleteError: "हटवण्यात अयशस्वी"
    }
};
